module.exports = __webpack_public_path__ + "static/media/Oxford-Park-Master-Deed.c804914e.pdf";